module.exports = __webpack_public_path__ + "static/img/partner_14.bff2228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_14.png
// module id = 9bef
// module chunks = 0